import { useQuery } from "@tanstack/react-query";
import { useCompanyAxis } from "@/api/use-company-context";
import { useSessionScope } from "@/auth/use-session-scope";
import { useEffectivePermissions } from "@/features/roles-permissions/use-effective-permissions";
import { fetchCapabilities, type Capabilities } from "./api";

// Menü, talep seçici ve sayfalar aynı yüklemleri okur; biri genişlerse diğerleri
// kendiliğinden izler (kopya yetki listesi dar yöne kayar).
export const canCreateStaffRequisition = (value: Capabilities | undefined): boolean => value?.enabled === true && value.can_create;
/** Kendi listesi birim yöneticisine açılır; bayrak kapalıyken de geçmiş talepler okunur. */
export const canOpenMyStaffRequisitions = (value: Capabilities | undefined): boolean => value?.can_create === true;
export const canManageStaffRequisitions = (value: Capabilities | undefined): boolean => value?.can_manage === true;
export const staffRequisitionKey = (scope: readonly string[]) => ["staff-requisitions", ...scope] as const;

export function useStaffRequisitionAccess({ enabled = true }: { enabled?: boolean } = {}) {
  const scope = useSessionScope(); const company = useCompanyAxis();
  return useQuery({ queryKey: [...staffRequisitionKey(scope), "capabilities", company.active_legal_entity_id], queryFn: fetchCapabilities, enabled, staleTime: 30_000 });
}

/** Okuma hücresi olmayan çağıran için yetenek ucu hiç çağrılmaz; cevap 403 olurdu. */
export function useStaffRequisitionCreateAvailable(): boolean {
  const { capabilities } = useEffectivePermissions();
  const access = useStaffRequisitionAccess({ enabled: capabilities.has("staff_requisitions.read") });
  return canCreateStaffRequisition(access.data);
}
